<template>
  <TemplateEditor v-if="template" v-model="template" @save="saveTemplate" />
</template>
<script setup lang="ts">
import { useAdminStore } from '../../admin/adminStore'
import TemplateEditor from '@/questionnaire/components/TemplateEditor/TemplateEditor.vue'
import { successNotification } from '@/utils/notifications'
import { storeToRefs } from 'pinia'

const adminStore = useAdminStore()
const { template } = storeToRefs(adminStore)

const saveTemplate = () => {
  successNotification('Template saved')
  adminStore.saveTemplate()
}
</script>
